import React from 'react'

import DocumentPreviewLayout, {
  ViewType,
} from 'modules/documents/components/DocumentPreview/Layout'

interface Props {
  onClose: () => void
  filename: string
  contentType: string
  url: string
  isUrlAbsolute: boolean
  content?: React.ReactElement
}

export function InvoiceViewerLayout({
  onClose,
  filename,
  contentType,
  url,
  isUrlAbsolute,
  content,
}: Props) {
  return (
    <DocumentPreviewLayout
      onClose={onClose}
      fileViewerProps={{
        filename,
        mimeType: contentType,
        url,
        isUrlAbsolute,
      }}
      content={content}
      type={ViewType.INVOICE_DETAIL}
    />
  )
}
